import NewValuation from './components/NewValuation.jsx'
import GlobalSearch from './components/GlobalSearch.jsx'
import CountrySelect from './components/CountrySelect.jsx'
import RentRollImport from './components/RentRollImport.jsx'
import TenantsTable from './components/TenantsTable.jsx'
import CashFlowTable from './components/CashFlowTable.jsx'
import CashFlowReport from './components/CashFlowReport.jsx'
import GrowthRatesTable from './components/GrowthRatesTable.jsx'
import AssumptionGrowthRatesTable from './components/AssumptionGrowthRatesTable.jsx'
import MlaTable from './components/MlaTable.jsx'
import TiLcGrowth from './components/TiLcGrowth.jsx'
import AreaScheduleEditor from './components/AreaScheduleEditor.jsx'
import MarketRentGrowthTable from './components/MarketRentGrowthTable.jsx'
import LeasingEventsTable from './components/LeasingEventsTable.jsx'
import RentReviewsModal from './components/RentReviewsModal.jsx'
import RentReviewEventsTable from './components/RentReviewEventsTable.jsx'
import IndexationProfilesTable from './components/IndexationProfilesTable.jsx'
import IndexationEventsTable from './components/IndexationEventsTable.jsx'
import CreditLossTab from './components/CreditLossTab.jsx'
import OperatingExpensesTab from './components/OperatingExpensesTab.jsx'
import OpexGrowth from './components/OpexGrowth.jsx'
import CapitalExpenditureTab from './components/CapitalExpenditureTab.jsx'
import CapexGrowth from './components/CapexGrowth.jsx'
import DiscountingTab from './components/DiscountingTab.jsx'
import ExitPriceAssumptionsTab from './components/ExitPriceAssumptionsTab.jsx'
import ValuationSummaryTab from './components/ValuationSummaryTab.jsx'
import ValueBridgeTab from './components/ValueBridgeTab.jsx'
import FloatingValueConclusion from './components/FloatingValueConclusion.jsx'

// Registry for React components
export const components = {
  NewValuation,
  GlobalSearch,
  CountrySelect,
  RentRollImport,
  TenantsTable,
  CashFlowTable,
  CashFlowReport,
  GrowthRatesTable,
  AssumptionGrowthRatesTable,
  MlaTable,
  TiLcGrowth,
  AreaScheduleEditor,
  MarketRentGrowthTable,
  LeasingEventsTable,
  RentReviewsModal,
  RentReviewEventsTable,
  IndexationProfilesTable,
  IndexationEventsTable,
  CreditLossTab,
  OperatingExpensesTab,
  OpexGrowth,
  CapitalExpenditureTab,
  CapexGrowth,
  DiscountingTab,
  ExitPriceAssumptionsTab,
  ValuationSummaryTab,
  ValueBridgeTab,
  FloatingValueConclusion
}

